import {BaseEntity} from "./base-entity";

export class CustomPicklist extends BaseEntity{
    customPickListItemSequence: number;
    customPickListItemValue: string;
    customPickListTypeCode: string;

}